module.exports = "/_next/static/images/HeroMobile@2x-89e037dad093f6628d36b3c55dd2b684.webp";